import Vue from 'vue'
import utils from '@/utils/common'
import $ from 'jquery'
Vue.directive("showAddClass", {
	inserted: function(el, binding) {
		var flag = false;
		var handleScroll = () => {
			if ($(document).scrollTop() + $(window).height() > $(el).offset().top + $(el).height() - 200 &&
				$(document).scrollTop() < $(el).offset().top + $(el).height() && !flag) {
				flag = true;
				window.removeEventListener('scroll', handleScroll);
				// 出现在可是区域
				console.log(binding.value)
				$(el).addClass(binding.value);
			}
		};
		window.addEventListener('scroll', handleScroll);
	},
});
